import React from 'react';

import { cn } from '@/lib/utils';

interface InfoCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

export const InfoCard: React.FC<InfoCardProps> = ({ title, children, className }) => (
  <div className={cn('rounded-lg border border-zinc-200 bg-white p-4 dark:border-zinc-800 dark:bg-zinc-900', className)}>
    <h3 className="mb-3 text-sm font-semibold text-zinc-900 dark:text-white">{title}</h3>
    {children}
  </div>
);

interface InfoRowProps {
  icon?: React.ReactNode;
  label: string;
  value: string | null | undefined;
}

export const InfoRow: React.FC<InfoRowProps> = ({ icon, label, value }) => (
  <div className="flex items-start gap-2">
    {icon && <span className="mt-0.5 text-zinc-400">{icon}</span>}
    <div>
      <p className="text-xs font-medium text-zinc-500 dark:text-zinc-400">{label}</p>
      <p className="text-sm font-medium text-zinc-800 dark:text-zinc-200">{value || '-'}</p>
    </div>
  </div>
);
